import { compose, identity, path, merge } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import NumberInput from '../../modules/numberInput.jsx';

export default class CreateUserForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      lastExpirationValue: 1,
      lastRepresentativeValue: '',
      hasRepresentative: true,
    };
  }
  render() {
    const expirationTextbox = this.props.value.expirationDays === -1 ?
      '' :
      <NumberInput value={this.props.value.expirationDays} onChange={this.handleChange('expirationDays', identity)} min="1" max="100" />;
    
    const expirationInput = (
      <span>
        {expirationTextbox}
        <input type='checkbox'
          style={{ margin: '0px 5px' }}
          checked={this.props.value.expirationDays === -1}
          onChange={this.handleChange('expirationDays', compose(this.handleCheckboxClick, path(['target', 'checked'])))} />
        Ilimitado
      </span>
    );

    const representativeTextbox =
      this.state.hasRepresentative === false ? '' :
      <input type='text' value={this.props.value.representative} onChange={this.handleChange('representative', path(['target', 'value']))} />;

    const representativeInput = (
      <span>
        {representativeTextbox}
        <br />
        <input type='checkbox'
          style={{ margin: '0px 5px' }}
          checked={this.state.hasRepresentative === false}
          onChange={this.handleChange('representative', compose(this.handleRepresentativeCheckboxClick, path(['target', 'checked'])))} />
        Usar nombre de consultor
      </span>
    );

    return (
      <form>
        {this.renderInput('Nombre', 'name')}
        {this.renderInput('Email', 'email')}
        {this.renderRow('Solicitante', representativeInput)}
        {this.renderRow('Vigencia (días)', expirationInput)}
      </form>
    );
  }
  handleRepresentativeCheckboxClick(checked) {
    if (checked) {
      this.setState({
        lastRepresentativeValue: this.props.value.representative,
        hasRepresentative: false,
      });

      return '';
    }

    this.setState({
      hasRepresentative: true,
    });

    return this.state.lastRepresentativeValue;
  }
  handleCheckboxClick(checked) {
    if (checked) {
      this.setState({
        lastExpirationValue: this.props.value.expirationDays
      });
      return -1;
    }

    return this.state.lastExpirationValue;
  }
  renderInput(label, id) {
    const input = <input type='text' value={this.props.value[id]} onChange={this.handleChange(id, path(['target', 'value']))} />;
    return this.renderRow(label, input);
  }
  renderRow(label, input) {
    return (
      <div className='row form-group'>
        <label className='col-xs-3 col-xs-offset-2' style={{ textAlign: 'right' }}>{label}</label>
        <div className='col-xs-6'>
          {input}
        </div>
      </div>
    );
  }
  handleChange(field, getValue) {
    return (event) => {
      const value = getValue(event);
      this.props.onChange(merge(this.props.value, { [field]: value }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/users/CreateUserForm.jsx